// extracted by mini-css-extract-plugin
module.exports = {"bannerNotification":"_31b9e20","top":"_732c4b6","bottom":"_b8c8494"};